import script from "./2FA.vue?vue&type=script&setup=true&lang=js"
export * from "./2FA.vue?vue&type=script&setup=true&lang=js"

import "./2FA.vue?vue&type=style&index=0&id=1e6a3679&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6a3679"]])

export default __exports__